import { createFileRoute } from "@tanstack/react-router";
import DepressionTreatmentCost from "@/pages/DepressionTreatmentCost";
export const Route = createFileRoute("/depression-treatment-cost")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Depression Treatment Cost | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "How much does depression treatment cost? TMS, SAINT TMS, SPRAVATO, and ketamine pricing, insurance coverage, and financing in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "Depression Treatment Cost | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "How much does depression treatment cost? TMS, SAINT TMS, SPRAVATO, and ketamine pricing, insurance coverage, and financing in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/depression-treatment-cost",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/depression-treatment-cost",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <DepressionTreatmentCost />;
}
